// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamFollowRemoveBody = {
  teamId: string;
};

export type typeTeamFollowRemoveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { favoriteTeamIds: string[] };
};

export type typeTeamFollowRemoveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamFollowRemoveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamFollowRemoveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamFollowRemoveBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamFollowRemove(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamFollowRemoveBody);
  }

  return async function postTeamFollowRemove(
    payload: typeTeamFollowRemoveBody,
  ): Promise<typeTeamFollowRemoveOutput200 | typeTeamFollowRemoveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamFollowRemove" failed before calling the network. #938c696250ff`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#938c696250ff" },
        },
        data: null,
      } as typeTeamFollowRemoveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team-follow/remove`,
      httpMethod: "POST",
      options,
    })) as typeTeamFollowRemoveOutput200 | typeTeamFollowRemoveOutput400;
  };
}
